import { jsx as _jsx } from "react/jsx-runtime";
// Components
import { useStylesV2 } from '@kubit/web-ui-components';
// Styles
import { LineSeparatorRootWrapperStyled } from '../../components/line-separator/line-separator.component.styled';
// Constants
import { STYLES_NAME } from '../../constants/stylesName';
import { LineSeparatorAlignmentVariantType, LineSeparatorVariantsType, } from '../../designSystem/reloaded/commons/components/line-separator/variants';
const LineSeparatorComponent = ({ alignment = LineSeparatorAlignmentVariantType.HORIZONTAL, variant = LineSeparatorVariantsType.PRINCIPAL, testId, }) => {
    const styles = useStylesV2({
        styleName: STYLES_NAME.LINE_SEPARATOR,
        variantName: variant,
    });
    return (_jsx(LineSeparatorRootWrapperStyled, { id: `line-separator-${testId}`, styles: styles?.[alignment] }));
};
export { LineSeparatorComponent };
//# sourceMappingURL=line-separator.component.js.map